import styled from '@emotion/styled/macro';
import { ButtonGroup, Card, forPhoneOnly, forTabletPortraitDown, ICardProps, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { InfoIcon } from '../info-icon';

type ICard = Pick<ICardProps, 'size'>;

export const ChartCard = styled(Card)<ICard>`
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    overflow: hidden;
    user-select: none;

    ${(props): string => {
        const { size } = props;
        switch (size) {
            case 'large':
                return `
                height: 480px;

                ${forPhoneOnly(`
                    ${Granularities} {
                        margin-left: 0;
                        margin-top: 16px;
                    }
                `)};
                `;
            case 'medium':
                return `
                height: 520px;

                ${forTabletPortraitDown(`
                    ${Header} {
                        flex-direction: column;
                    }
                    ${Granularities} {
                        margin-left: 0;
                        margin-top: 16px;
                    }
                `)};
            `;
            case 'small':
            default:
                return '';
        }
    }}
`;

export const Header = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    margin: 0 24px 16px 24px;

    ${forTabletPortraitDown(`
        justify-content: center;
        flex-wrap: wrap;
    `)};
`;

export const Contents = styled.div<ICard>`
    display: flex;
    flex-direction: ${(props: ICard): string => (props.size === 'large' ? 'row' : 'column')};
    flex-grow: 1;
    padding: 0 24px;
    overflow: auto;
    align-items: ${(props: ICard): string => (props.size === 'large' ? 'stretch' : 'center')};

    ${forTabletPortraitDown(`
        flex-direction: column;
    `)};
`;

export const Title = styled.span`
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0.5px;
    color: ${Variables.Colors.p300};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
export const Spacer = styled.span`
    flex-grow: 1;
`;

export const StyledInfoIcon = styled(InfoIcon)`
    padding-left: 12px;
`;

export const Granularities = styled(ButtonGroup)`
    margin-left: 16px;
`;

export const Caption = styled.span`
    ${forTabletPortraitDown(`
        display: none;
    `)};
`;
export const Captioned = styled.span`
    display: inline-flex;
    margin-left: 40px;
    font-size: 15px;
    color: ${Variables.Colors.n50};
`;

export const OptionsLink = styled.a`
    cursor: pointer;
    &:hover {
        fill: ${Variables.Colors.n50};
    }
    &:active {
        fill: ${Variables.Colors.n30};
    }
`;

export const OptionsIcon = styled(Icon)`
    height: 20px;
    width: 20px;
    margin-top: 2px;
    fill: ${Variables.Colors.nx24};
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 16px 24px 0px 24px;
`;
export const FooterLink = styled.span`
    display: flex;
    color: ${Variables.Colors.p200};
    letter-spacing: 0.2px;
    white-space: nowrap;
    font-size: 16px;
    line-height: 18px;
    & > a {
        display: flex;
        color: ${Variables.Colors.p200};
        line-height: 18px;
    }
`;
export const FooterLinkIcon = styled(Icon)`
    display: flex;
    vertical-align: middle;
    fill: ${Variables.Colors.p200};
    height: 18px;
    width: 18px;
    margin-left: 4px;
`;
